__webpack_require__.p = "/bsChart/";